"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BaseSkeleton: ()=>BaseSkeleton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const BaseSkeleton = ({ type, className, skeletonSlot, skeletonImageSlot, styles, ...props })=>{
    const isImage = 'image' === type;
    const skeletonClass = (0, index_cjs_namespaceObject.cn)(skeletonSlot, className);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("output", {
        "aria-label": "loading",
        "data-testid": "skeleton",
        className: isImage ? skeletonClass : `${skeletonClass} animate-skeleton-pulse`,
        ...(0, index_cjs_namespaceObject.cleanProps)(props, [
            'type',
            'emphasis',
            'animate'
        ]),
        style: styles,
        children: isImage ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: skeletonImageSlot
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                    "data-testid": "loading-img",
                    iconName: "image",
                    size: "24",
                    className: "text-primary-6 relative",
                    "aria-hidden": "true"
                })
            ]
        }) : null
    });
};
exports.BaseSkeleton = __webpack_exports__.BaseSkeleton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BaseSkeleton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
